
import React, { Suspense, useState, useEffect } from "react";
import systemListingService from "./SystemListingServices";
import Pagination from "components/Common/newPagination";
import AnalysisCodeUpsert from "./upsert/AnalysisCodeUpsert";
import DeleteDialogueBox from "components/Common/deleteDialogue";
import { CommonUtilities } from "commonUtils";

export default function AnalysisCodesPage(param: any) {
  let [searchFor, setsearchFor] = useState("");
  let [editDawer, setEditDawer] = useState<any>(false);
  let [showDims, setShowDims] = useState(false);
  let [editingOn, setEditingOn] = useState(false);
  let [editDataDawer, setEditDataDawer] = useState<any>([]);
  let [analsisCodeListing, SetAnalsisCodeListing] = useState<any>([]);
  let [activeCategory, setActiveCategory] = useState<Category>("Recorded Music");
  let [analsisCodeCount, setAnalsisCodeCount] = useState<number>(0);

  console.log(param)

  useEffect(() => {
    searchFor = '';
    setsearchFor(searchFor);
    if (param.activeTab === "Analysis codes") {
      analysisTypeSelect("Recorded Music")
    }
  }, [param])


  type Category = "Recorded Music" | "Mechanical" | "Publishing" | "Costs" | "Advances" | "Licensing";
  const categories: Category[] = ["Recorded Music", "Mechanical", "Publishing", "Costs", "Advances", "Licensing",];

  const openAddDrawer = (code: any) => {
    if (code) {
      setEditDataDawer(code)
    }
    editDawer = true
    setEditDawer(editDawer);
    console.log(editDawer)

  };

  const analysisTypeSelect = (analysisType: any) => {
    console.log(analysisType)
    setActiveCategory(analysisType);

    analsisCodeCount = 0;
    setAnalsisCodeCount(analsisCodeCount)

    var payload = {
      pageNumber: 1,
      pageSize: 10,
      searchFor: searchFor
    }

    if (analysisType === "Recorded Music") {
      systemListingService.getSalesAnalysissales(payload).then(respond => {
        SetAnalsisCodeListing(respond)
        analsisCodeCount = respond && respond[0].totalRows ? respond[0].totalRows : 0
        setAnalsisCodeCount(analsisCodeCount);
      })
    }

    if (analysisType === "Mechanical") {
      systemListingService.getSalesAnalysismechanical(payload).then((respond: any) => {
        SetAnalsisCodeListing(respond)
        analsisCodeCount = respond && respond[0].totalRows ? respond[0].totalRows : 0
        setAnalsisCodeCount(analsisCodeCount);
      })
    }


    if (analysisType === "Publishing") {
      systemListingService.getSalesAnalysispublishing(payload).then((respond: any) => {
        SetAnalsisCodeListing(respond)
        analsisCodeCount = respond && respond[0].totalRows ? respond[0].totalRows : 0
        setAnalsisCodeCount(analsisCodeCount);
      })
    }

    if (analysisType === "Costs") {
      systemListingService.getSalesAnalysiscosts(payload).then((respond: any) => {
        SetAnalsisCodeListing(respond)
        analsisCodeCount = respond && respond[0].totalRows ? respond[0].totalRows : 0
        setAnalsisCodeCount(analsisCodeCount);
      })
    }

    if (analysisType === "Advances") {
      systemListingService.getSalesAnalysisadvances(payload).then((respond: any) => {
        SetAnalsisCodeListing(respond)
        analsisCodeCount = respond && respond[0].totalRows ? respond[0].totalRows : 0
        setAnalsisCodeCount(analsisCodeCount);
      })
    }

    if (analysisType === "Licensing") {
      systemListingService.getSalesAnalysislicensing(payload).then((respond: any) => {
        SetAnalsisCodeListing(respond)
        analsisCodeCount = respond && respond[0].totalRows ? respond[0].totalRows : 0
        setAnalsisCodeCount(analsisCodeCount);
      })
    }


  }

  const onPageChange = (e: any) => {
    console.log(e)
  }

  const closeDrawer = () => {
    editDawer = false
    setEditDawer(editDawer);
    console.log(editDawer)
  }

  const sliderChange = (typeFor: any, e: any) => {
    console.log(e)
    if (typeFor == "Mechanicals") {
      if (e?.mechanicalBearing == 1) {
        e.mechanicalBearing = 0;
      }

      if (e?.mechanicalBearing == 0) {
        e.mechanicalBearing = 1;
      }
    }

    if (typeFor == "Default") {
      if (e?.isDefault == 1) {
        e.isDefault = 0;
      }

      if (e?.isDefault == 0) {
        e.isDefault = 1;
      }
    }

    console.log(e)

  }

  const dropDownChange = (type: any, e: any, object_upsert: any) => {
    console.log(object_upsert)
    console.log(type)
    console.log(e)

    if (type == "Type") {

      if (e == "sales") {
        object_upsert.salesCode = 1;
        object_upsert.costsCode = 0;
        object_upsert.advanceCode = 0;
        object_upsert.flatFeeCode = 0;
        object_upsert.publCode = 0;
      }

      if (e == "flatFee") {
        object_upsert.salesCode = 0;
        object_upsert.costsCode = 0;
        object_upsert.advanceCode = 0;
        object_upsert.flatFeeCode = 1;
        object_upsert.publCode = 0;
      }

      if (e == "publishingInc") {
        object_upsert.salesCode = 0;
        object_upsert.costsCode = 0;
        object_upsert.advanceCode = 0;
        object_upsert.flatFeeCode = 0;
        object_upsert.publCode = 1;
      }

      if (e == "costs") {
        object_upsert.salesCode = 0;
        object_upsert.costsCode = 1;
        object_upsert.advanceCode = 0;
        object_upsert.flatFeeCode = 0;
        object_upsert.publCode = 0;
      }

      if (e == "advances") {
        object_upsert.salesCode = 0;
        object_upsert.costsCode = 0;
        object_upsert.advanceCode = 1;
        object_upsert.flatFeeCode = 0;
        object_upsert.publCode = 0;
      }
    }

    if (type == "PointProfit") {

      if (e == "both") {
        object_upsert.useInPoints = 1;
        object_upsert.useInProfit = 1;
      }

      if (e == "pointsOnly") {
        object_upsert.useInPoints = 1;
        object_upsert.useInProfit = 0;
      }

      if (e == "profitOnly") {
        object_upsert.useInPoints = 0;
        object_upsert.useInProfit = 1;
      }

      if (e == "neither") {
        object_upsert.useInPoints = 0;
        object_upsert.useInProfit = 0;
      }
    }

    console.log(object_upsert)
  }


  let [deleteData, setDeleteData] = useState<any>([]);
  let [deleteStatus, setDeleteStatus] = useState(false);
  const deleteSelection = (e: any) => {
    console.log(e)
    deleteData = e
    setDeleteData(deleteData)

    deleteStatus = true;
    setDeleteStatus(deleteStatus)
  }

  const deleteConfirmation = (e: any) => {
    console.log(e)

    //e==1 YES
    if (e == 1) {
      systemFormatsList.deleteAnalysisCode(deleteData).then((respond: any) => {
        CommonUtilities.showToastDawer('Analysis codes delete Successfull', 'Success')
      })
    }
    //e==2 NO
    deleteStatus = false;
    setDeleteStatus(deleteStatus)
  }

  const csvFormatHeadersRaw = function (type: any) {
    systemListingService.SalesAnalysisExport({ filter: type == 'all' ? type : activeCategory })
  };

  const slider_handler = (e: any, selectData: any) => {
    
    if (e.target.type == "checkbox") { 

      selectData[e?.target?.name] = selectData[e?.target?.name] == 1 ? 0 : 1
       
      systemListingService.saveSalesAnalysissales(selectData).then((repond: any) => {
        analysisTypeSelect(activeCategory);
      })
    }
  }

  return (
    <>
      <div className="content-card ws-12">

        <div className="ws-12">
          <div className="ws-12 card-title">Analysis Codes</div>

          <div className="ws-12">

            <div className="ws-9 nav nav-tabs nav-justified p0 m0 pt pb">
              {categories.map((cat) => (
                <button key={cat} className={"icon-btn edit" + (cat === activeCategory ? " fill" : "")} onClick={() => { setActiveCategory(cat); analysisTypeSelect(cat) }}  >
                  {cat}
                </button>
              ))}
            </div>

            <div className="ws-3">

              <button className="icon-btn primary fill pull-right" type="button" disabled={!editingOn} onClick={() => openAddDrawer({})}  >
                Add Analysis Code
              </button>

              <div className="hover-box m0 ml pull-right">
                <button className="icon-btn primary height35"> <i className="icon-download1"></i></button>
                <div className="hover-block mtxl">
                  <a className="icon-btn info btn-sm text-s mt" onClick={() => csvFormatHeadersRaw(activeCategory)} >Export {activeCategory}</a>
                  <a className="icon-btn info btn-sm text-s mt" onClick={() => csvFormatHeadersRaw("all")}>Export All</a>
                </div>
              </div>

            </div>

          </div>

          <div className="ws-12 mb">

            <span className="pt mt pull-left"> {analsisCodeCount} record(s) found  </span>

            <button className="icon-btn info pull-right" id="editModeBtn" type="button" onClick={() => setEditingOn((prev) => !prev)}   >
              {editingOn ? "Edit Mode: On" : "Edit Mode: Off"}
            </button>

          </div>
        </div>

        <div className="ws-12 pm mbxl" style={{ borderRadius: 8, border: "1px solid #e5e7eb" }}  >
          <div className="ws-12"  >

            <div className="ws-6">
              <div className="ws-12 text-bold pbl">Filter</div>
              <input className="ws-10" placeholder="By code, description or group" value={searchFor} onChange={(e) => setsearchFor(e.target.value)} style={{ minWidth: 420 }} />
              <button className="icon-btn primary" type="button" onClick={() => analysisTypeSelect(activeCategory)}>Search</button>
            </div>

            {/* DIM Columns toggle */}
            <div className="ws-6" >
              <div className="ws-12 text-bold text-m text-right">DIM Columns</div>

              <label className="switch mtl pull-right">
                <input type="checkbox" name="showDims" checked={showDims} onClick={() => setShowDims((prev) => !prev)} />
                {showDims && <span className="slider round text-left white pm pts" >Yes</span>}
                {!showDims && <span className="slider round text-right white pm pts sliderOff">No</span>}
              </label>

            </div>

          </div>
        </div>

        <div className=" ws-12">

          {analsisCodeListing.length > 0 && <>

            <table className={editingOn ? "editing-on newTable" : " newTable"} >
              <thead>
                <tr>
                  {showDims ? (
                    <>
                      <th >Code</th>
                      <th >DIM 1 Db</th>
                      <th >DIM 2 Cr</th>
                      <th >DIM 3 Db</th>
                      <th >DIM 4 Cr</th>
                      <th style={{ width: "22%" }}>Operations</th>
                    </>
                  ) : (
                    <>
                      <th >Code</th>
                      <th >Description</th>
                      <th >Group</th>
                      <th >Points / Profits</th>
                      <th >Type</th>
                      <th >Mechanicals</th>
                      <th style={{ width: "22%" }}>Operations</th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody>
                {analsisCodeListing.map((AnalysisRow: any) => (
                  <tr key={AnalysisRow.code} className={AnalysisRow.isDefault ? "default-row" : ""} >
                    {showDims ? (
                      <>
                        <td >{AnalysisRow.analysisCode}</td>
                        <td >{AnalysisRow.analysisDIM1}</td>
                        <td >{AnalysisRow.analysisDIM2}</td>
                        <td >{AnalysisRow.analysisDIM3}</td>
                        <td >{AnalysisRow.analysisDIM4}</td>
                        <td className="forceSingleLine" style={{ width: "15%", padding: "12px 8px" }}>
                          <div style={{ pointerEvents: editingOn ? "auto" : "none", opacity: editingOn ? 1 : 0.6, cursor: editingOn ? "pointer" : "not-allowed", }}  >
                            <button className={"icon-btn info fill" + (AnalysisRow.isDefault === 1 ? " active" : "")} type="button" disabled={!editingOn}> Default</button>

                            <button className="icon-btn edit" title="Edit" type="button" disabled={!editingOn} onClick={() => openAddDrawer(AnalysisRow)}>
                              <i className="icon-pencil"> </i>
                            </button>

                            <button className="icon-btn delete" title="Delete" type="button" disabled={!editingOn} onClick={() => deleteSelection(AnalysisRow)}>
                              <i className="icon-trash"> </i>
                            </button>
                          </div>
                        </td>
                      </>
                    ) : (
                      <>
                        <td >{AnalysisRow.analysisCode}</td>
                        <td >{AnalysisRow.analysisText}</td>
                        <td >{AnalysisRow.analysisSort}</td>
                        <td >
                          <select disabled={!editingOn} onChange={(e: any) => dropDownChange('PointProfit', e.target.value, AnalysisRow)} name="PointProfit"  >
                            <option value="both">Both</option>
                            <option value="pointsOnly">Points Only</option>
                            <option value="profitOnly">Profit Only</option>
                            <option value="neither">Neither</option>
                          </select>

                        </td>
                        <td >
                          <select disabled={!editingOn} onChange={(e: any) => dropDownChange('Type', e.target.value, AnalysisRow)}>
                            <option value="sales">Sales</option>
                            <option value="flatFee">Flat Fee</option>
                            <option value="publishingInc">Publishing</option>
                            <option value="costs">Costs</option>
                            <option value="advances">Advances</option>
                          </select>
                        </td>

                        <td >

                          <label className="switch" style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}} >
                            <input type="checkbox" checked={AnalysisRow?.mechanicalBearing === 1} name="mechanicalBearing" onChange={(e: any) => slider_handler(e, AnalysisRow)} />
                            {AnalysisRow?.mechanicalBearing === 1 && <span className="slider round text-left white pm pts" >Yes</span>}
                            {AnalysisRow?.mechanicalBearing === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                          </label>

                        </td>

                        <td className="forceSingleLine" style={{ width: "15%" }}  >
                          <div style={{ opacity: editingOn ? 1 : 0.6, cursor: editingOn ? "pointer" : "not-allowed", }}  >
                            <button className={"icon-btn info fill" + (AnalysisRow.isDefault ? " active" : "")} type="button" disabled={!editingOn} onClick={() => sliderChange("Default", AnalysisRow)}>
                              Default
                            </button>

                            <button className="icon-btn edit" title="Edit " type="button" disabled={!editingOn} onClick={() => openAddDrawer(AnalysisRow)}>
                              <i className="icon-pencil"></i>
                            </button>

                            <button className="icon-btn delete" title="Delete" type="button" disabled={!editingOn} onClick={() => deleteSelection(AnalysisRow)}>
                              <i className="icon-trash"> </i>
                            </button>
                          </div>
                        </td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>

            {analsisCodeListing.length > 10 && <>
              <Pagination totalRow={analsisCodeListing.length} onPageChange={onPageChange} />
            </>}
          </>}

          {analsisCodeListing.length === 0 && <div className="alert alert-info ws-12 box" >No records to display</div>}
        </div>

      </div>

      {(() => {

        if (editDawer === true) {
          return <AnalysisCodeUpsert editDawer={editDawer} editDataDawer={editDataDawer} closeDrawer={closeDrawer} activeCategory={activeCategory} />
        }

        if (deleteStatus) {
          return <DeleteDialogueBox param={deleteStatus} message={"delete the selected analysis code " + deleteData?.analysisCode} onChange={deleteConfirmation} />
        }

      })()}
    </>
  );
}; 